import React, {useContext, useEffect, useState} from "react";
import $ from "jquery";
import moment from "moment";
import FormSheet from "../../../overbox/sheet/FormSheet";
import LoaderCircle from "../../../tools/loader/LoaderCircle";
import Listing from "../../../tools/table/Listing";
import AddIcon from "../../../icons/AddIcon";
import ContractController from "../../../../stories/_client/Contract/ContractController";
import StoreController from "../../../../stories/_client/Stores/StoreController";
import AppContext from "../../../../context/AppContext";
import "moment/locale/fr";
import "../../../../css/page/contents/client/ClientContracts.css";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";

const ClientContracts = props => {
    moment.locale("fr");
    const { inDatas } = props;
    const { setEvent, setGetDatasPopup } = useContext(AppContext);
    const [ datas, setDatas ] = useState(inDatas);
    const [ contracts, setContracts ] = useState(null);
    const [ stateNextContracts, setStateNextContracts ] = useState(null);
    const [ innerObjectType, setInnerObjectType ] = useState(null);
    const [ innerDatas , setInnerDatas ] = useState(null);
    const [ sortingName, setSortingName ] = useState("id");
    const [ sortingValue, setSortingValue ] = useState("asc");
    const [ menuContract, setMenuContract ] = useState(null);

    const getStore = () => {
        const controller = new StoreController();
        controller._callback = returnGetStore;
        controller.show(datas.store.id);
    }
    const returnGetStore = (object, error, status) => {
        switch (status) {
            case 200:
                let datasTmp = Object.assign({}, datas);
                datasTmp.store = object;
                setDatas(datasTmp);
                setGetDatasPopup(prev => ({
                    ...prev,
                    store: object
                }));

                break;
            default:
                break;
        }
    }
    const getContracts = () => {
        const controller = new ContractController();
        controller._callback = returnGetContracts;
        controller.index(datas.store.id);
    }
    const returnGetContracts = (list, error, status) => {
        switch (status) {
            case 200:
                let datasTmp = Object.assign({}, datas);
                datasTmp.contracts = list;
                setContracts(list);
                setGetDatasPopup(prev => ({
                    ...prev,
                    contracts: list
                }));

                break;
            default:
                setEvent({
					type: "error",
					text: "Une erreur s'est produite lors de la récupération des contrats"
				});
                break;
        }
    }
    const getStateNextContracts = () => {
        const controller = new ContractController();
        controller._callback = returnGetStateNextContracts;
        controller.stateNextContracts(datas.store.id);
    }
    const returnGetStateNextContracts = (response, error, status) => {
        switch (status) {
            case 200:
                setStateNextContracts(response.data);
                break;
            default:
                console.error("Error to get next state contracts", error);
                break;
        }
    }
    const callNewContract = () => {
        if (!datas.store.has_setup) return;

		if (!datas.store.legal_datas === null) {
			setEvent({
				type: "error",
				text: "Vous devez inscrire les informations légales de la société avant de pouvoir ajouter un contrat"
			});
			return;
		}
		else if (datas.store.legal_datas.iban === null) {
			setEvent({
				type: "error",
				text: "Vous devez saisir les informations bancaires de la société avant de pouvoir ajouter un contrat"
			});
			return;
		}

        setInnerObjectType("newContract");
        setInnerDatas({
            store: datas.store,
			states: stateNextContracts
        });
    }
    const callCompletedContract = () => {
        setInnerObjectType("fileContract");
        setInnerDatas({
            store: datas.store,
			contract: Object.assign({}, menuContract)
        });
		setMenuContract(null);
    }
    const callUpdateContract = () => {
        setInnerObjectType("updateContract");
        setInnerDatas({
            store: datas.store,
			states: stateNextContracts,
			contract: Object.assign({}, menuContract)
        });
		setMenuContract(null);
    }
    const callTerminatedContract = () => {
        setInnerObjectType("terminateContract");
        setInnerDatas({
            store: datas.store,
			contract: Object.assign({}, menuContract)
        });
		setMenuContract(null);
    }
    const stateInnerPopup = () => {
        return innerObjectType !== null
    }
    const stateInnerForm = () => {
        switch (innerObjectType) {
			case "newContract":
			case "updateContract":
                if (stateNextContracts !== null && innerDatas !== null)
                    return true;

                break;
            case "fileContract":
            case "terminateContract":
                if (innerDatas !== null)
                    return true;

                break;
            default: break;
        }

        return false;
    }
    const titleFormSheet = () => {
        switch (innerObjectType) {
            case "newContract":
                return "Créer un contrat";
            case "fileContract":
                return "Déposer le contrat";
            case "updateContract":
                return "Modifier le contrat";
            case "terminateContract":
                return "Résilier le contrat";
            default:
                return "";
        }
    }
    const closeInnerForm = () => {
        setInnerObjectType(null);
        setInnerDatas(null);
    }
    const returnInnerForm = () => {
        closeInnerForm();
        getContracts();
		getStore();
    }
	const handleContractMenu = contract => {
        if (menuContract !== null && contract.id === menuContract.id)
            setMenuContract(null);
        else {
            let menuId = "#menuContract";
            let addContractFileId = "#addContractFile";
            let terminatedContractId = "#terminatedContract";
            let editIconId = "#editContract-" + contract.id;
            let offset = $(editIconId).offset();

            if (contract.contract_file === null) {
                $(addContractFileId).show();
            }
            else {
                $(addContractFileId).hide();
            }

            if (contract.terminated_on === null) {
                $(terminatedContractId).show();
            }
            else {
                $(terminatedContractId).hide();
            }

            $(menuId).css({left: (offset.left - $(menuId).width() + $(editIconId).outerWidth()) + "px", top: (offset.top + $(editIconId).outerHeight() + 5) + "px"});
            setMenuContract(contract);
        }
	}

    const model = [
        {
            "class": "id",
            "sortingParam": "",
            "title": "#",
            "attributes": ["id"],
            "type": "text"
        },
        {
            "class": "groupName",
            "sortingParam": "",
            "title": "Type",
            "attributes": ["licenseType"],
            "type": "text"
        },
        {
            "class": "name",
            "sortingParam": "",
            "title": "Licence",
            "attributes": ["license"],
            "type": "text"
        },
        {
            "class": "state",
            "sortingParam": "",
            "title": "état",
            "attributes": ["state"],
            "type": "state"
        },
        {
            "class": "commitment",
            "sortingParam": "",
            "title": "Engagement",
            "attributes": ["commitment"],
            "type": "commitment"
        },
        {
            "class": "date",
            "sortingParam": "",
            "title": "Début",
            "attributes": ["begin"],
            "type": "date"
        },
        {
            "class": "date",
            "sortingParam": "",
            "title": "Fin",
            "attributes": ["end"],
            "type": "date"
        },
        {
            "class": "amount",
            "sortingParam": "",
            "title": "Montant",
            "attributes": ["amountExclTax"],
            "type": "price"
        },
        {
            "class": "creator",
            "sortingParam": "",
            "title": "Créer par",
            "attributes": ["creator"],
            "type": "text"
        }
    ];

    useEffect(() => {
        getContracts();
        getStateNextContracts();
    }, []);

    return (
        <>
            <div className={"overlay" + (stateInnerPopup() ? " appear" : "")}>
                <div className={"wrapPopup"}>
                    <div className={"popup " + (stateInnerForm() ? "new" : "loading")}>
                        {
                            stateInnerForm()
                                ? <FormSheet
                                    objectType={ innerObjectType }
                                    datas={ innerDatas }
                                    parentDatas={ datas }
                                    title={ titleFormSheet() }
                                    callbackClose={ closeInnerForm }
                                    callbackSuccess={ returnInnerForm } />
                                : <div className={"containerLoading"}>
                                    <LoaderCircle display="loader inPopup" hide="" strokeWidth="10" stroke="#00000070" />
                                </div>
                        }
                    </div>
                </div>
            </div>
            <Listing
                item={ "contracts" }
                itemClass={ "contract" }
                titleNbItems={ "contrats" }
                emptyList={ "aucun contrat" }
                model={ model }
                pageSelect={ 1 }
                updatePageSelect={ null }
                list={ contracts !== null ? contracts : [] }
                loading={ contracts === null }
                pagination={ null }
                checkable={ false }
                openable={ true }
                preview={ false }
                setPerPage={ null }
                sortingName={ sortingName }
                sortingValue={ sortingValue }
                setSortingName={ setSortingName }
                setSortingValue={ setSortingValue }
				handleMenu={ handleContractMenu }
			/>
			<ul id={"menuContract"} className={"menuContract" + (menuContract !== null ? " appear" : "")}>
				<li id={"addContractFile"} onClick={ callCompletedContract }>
					<p>Ajouter le fichier du contrat</p>
				</li>
				<li onClick={ callUpdateContract }>
					<p>Modifier le contract</p>
				</li>
				<li id={"terminatedContract"} className={"red"} onClick={ callTerminatedContract }>
					<p>Résilier le contract</p>
				</li>
			</ul>
            <button className={"addButton"} onClick={callNewContract}>
              <AddIcon/>
              <p>Ajouter un contrat</p>
            </button>
        </>
    )
}

export default ClientContracts;